// extracted by mini-css-extract-plugin
module.exports = {"VirtualSlotsRow":"VirtualSlotsRow__3WO0Y","Day":"Day__1-K-J"};